import React from 'react';
import styles from './DevicesList.module.scss';

const GlobalPayDevicesList = (props) => {
  const getConfiguredDevicesList = () => {
    const { globalPayDeviceIds, deleteGlobalPayDeviceId } = props;
    if (!!globalPayDeviceIds) {
      return globalPayDeviceIds.map((val, i) => {
        if (!!val[0]) {
          return (
            <tr key={i} className={styles.deviceIdItem}>
              <td>{val[0]}</td>
              <td>{val[1]}</td>
              <td
                className={styles.deviceIdItemAction}
                onClick={() => deleteGlobalPayDeviceId(val)}
              >
                <i className='fas fa-trash-alt'></i>
              </td>
            </tr>
          );
        }
        return null;
      });
    } else {
      return (
        <tr className={styles.deviceIdItem}>
          <td>No Devices Listed</td>
        </tr>
      );
    }
  };

  return (
    <table className={`${styles.deviceListTable}`}>
      <thead>
        <tr>
          <th scope='col'>Device Id</th>
          <th scope='col'>Name</th>
        </tr>
      </thead>
      <tbody className={`${styles.deviceListTableBody}`}>
        {getConfiguredDevicesList()}
      </tbody>
    </table>
  );
};

export default GlobalPayDevicesList;
